const opts = (x) => [x.size ? `Tam ${x.size}` : '', x.color ? `Cor ${x.color}` : ''].filter(Boolean).join(' · ');

export const OrderItemsDetail = ({ items, testid }) => (
  <ul className="space-y-1.5 text-xs min-w-[200px]" data-testid={testid}>
    {(items || []).map((it, i) => (
      <li key={i}>
        <span className="font-semibold text-[#1A1A1A]">{it.product_name} x{it.quantity}</span>
        {!it.is_combo && opts(it) && <span className="text-[#73706A]"> — {opts(it)}</span>}
        {it.is_combo && (
          <ul className="pl-3 mt-0.5 text-[#73706A] space-y-0.5">
            {(it.combo_selections || []).length > 0
              ? it.combo_selections.map((s, j) => (
                  <li key={j}>• {s.product_name}{opts(s) ? ` — ${opts(s)}` : ''}</li>
                ))
              : <li>{it.combo_contents}</li>}
          </ul>
        )}
      </li>
    ))}
  </ul>
);

export const CartLineOptions = ({ line }) =>
  line.is_combo ? (
    <ul className="text-[11px] text-[#73706A] mt-0.5 space-y-0.5">
      {(line.selections || []).map((s, j) => (
        <li key={j}>• {s.product_name}{opts(s) ? ` — ${opts(s)}` : ''}</li>
      ))}
    </ul>
  ) : (
    <p className="text-[11px] text-[#73706A]">{opts(line)}</p>
  );
